(() => {
  if (window.rainbowClassicSticky) return;
  window.rainbowClassicSticky = true;
  const instances = new Map();
  let paused = false;
  function initialize() {
    if (paused) return;
    document.querySelectorAll('.custom-sticky[data-pdp-section]').forEach(sticky => {
      if (instances.has(sticky)) return;
      const form = document.getElementById(`product-form-${sticky.dataset.pdpSection}`);
      if (!form) return;
      const input = form.querySelector('.product-quantity__selector');
      const qty = sticky.querySelector('.custom-sticky-qty-selector');
      const button = sticky.querySelector('.custom-sticky-add-cart-button');
      const mainButton = form.querySelector('[data-js-product-add-to-cart]');
      const price = sticky.querySelector('.product-info-price span.price');
      function bounds(value) {
        const min = Number(input?.min) || 1;
        const max = Math.min(Number(input?.max) || 99, 99);
        return Math.max(min, Math.min(max, Number(value) || min));
      }
      function updatePrice() {
        if (!qty) return;
        if (input) qty.value = input.value;
        const amount = Number(qty.value) * Number(qty.dataset.currentPrice);
        if (price) price.innerHTML = formatMoney(Number.isFinite(amount) ? amount : 0, KROWN.settings.shop_money_format_with_currency);
      }
      function change(value) {
        if (!qty) return;
        qty.value = bounds(value);
        if (input) input.value = qty.value;
        updatePrice();
      }
      function click(event) {
        const control = event.target.closest('.custom-sticky-qty-change');
        if (control && !control.classList.contains('disabled')) {
          change(Number(qty?.value) + (control.classList.contains('c-qty-minus') ? -1 : 1));
        }
        if (event.target.closest('.custom-sticky-add-cart-button') &&
          mainButton && !mainButton.disabled && !mainButton.classList.contains('disabled')) mainButton.click();
      }
      function stickyInput(event) { if (event.target === qty) change(qty.value); }
      function mainInput() { change(input.value); }
      function scroll() {
        if (!form.isConnected || !sticky.isConnected) { unmount(); return; }
        if (input) change(input.value);
        if (button && mainButton) {
          button.innerHTML = mainButton.innerHTML;
          button.disabled = mainButton.disabled || mainButton.classList.contains('disabled');
          button.classList.toggle('disabled', button.disabled);
        }
        updatePrice();
        const show = form.getBoundingClientRect().bottom <= 0;
        sticky.classList.toggle('show', show);
        document.documentElement.style.paddingBottom = show ? `${sticky.offsetHeight}px` : '0px';
      }
      sticky.addEventListener('click', click);
      function unmount() {
        instances.get(sticky)?.cleanup();
        instances.delete(sticky);
      }
      sticky.addEventListener('pdp:availability:unmount', unmount);
      sticky.addEventListener('input', stickyInput);
      input?.addEventListener('input', mainInput);
      window.addEventListener('scroll', scroll);
      instances.set(sticky, {
        form,
        cleanup() {
          sticky.removeEventListener('click', click);
          sticky.removeEventListener('pdp:availability:unmount', unmount);
          sticky.removeEventListener('input', stickyInput);
          input?.removeEventListener('input', mainInput);
          window.removeEventListener('scroll', scroll);
          document.documentElement.style.paddingBottom = '';
        }
      });
    });
  }
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, sticky) => {
      if (event.target.contains(instance.form)) {
        instance.cleanup();
        if (!event.target.contains(sticky)) sticky.remove();
        instances.delete(sticky);
      }
    });
  });
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pagehide', () => {
    paused = true;
    instances.forEach(instance => instance.cleanup());
    instances.clear();
  });
  window.addEventListener('pageshow', () => { paused = false; initialize(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
